import { render, staticRenderFns } from "./GeneralSettingsCard.vue?vue&type=template&id=6a884da0&scoped=true"
import script from "./GeneralSettingsCard.vue?vue&type=script&lang=js"
export * from "./GeneralSettingsCard.vue?vue&type=script&lang=js"
import style0 from "./GeneralSettingsCard.vue?vue&type=style&index=0&id=6a884da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a884da0",
  null
  
)

export default component.exports